import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { FormattedCurrencyAmount } from '@swf/poker';

import { useTicker } from '../hooks/useTicker';

import {
  TXTCLI_Watch_N0_win_a_N1_prize_from_a_ELL,
  TXTCLI_Watch_a_N0_jackpot_LIVE_NowX
} from './Ticker.messages.json';
import styles from './Ticker.scss';

const Ticker: React.FC = React.memo(() => {
  const isPlayMoney = useSelector(select.currency.isPlayMoney);
  const tickerMessage = useTicker();

  if (!tickerMessage) {
    return null;
  }

  const { prize, currency, winner, buyIn } = tickerMessage;

  const translationProps = winner
    ? {
        translation: TXTCLI_Watch_N0_win_a_N1_prize_from_a_ELL,
        values: {
          0: winner,
          1: (
            <FormattedCurrencyAmount
              amount={prize}
              isPlayMoney={isPlayMoney}
              currency={currency}
              notationPM="compact"
              currencyDisplay="narrowSymbol"
            />
          ),
          2: (
            <FormattedCurrencyAmount
              amount={buyIn}
              isPlayMoney={isPlayMoney}
              currency={currency}
              notationPM="compact"
              currencyDisplay="narrowSymbol"
            />
          )
        }
      }
    : {
        translation: TXTCLI_Watch_a_N0_jackpot_LIVE_NowX,
        values: {
          0: (
            <FormattedCurrencyAmount
              amount={prize}
              isPlayMoney={isPlayMoney}
              currency={currency}
              notationPM="compact"
              currencyDisplay="narrowSymbol"
            />
          )
        }
      };

  return (
    <div className={styles.tickerContainer}>
      <div className={styles.ticker}>
        <Translation
          tagName="span"
          {...translationProps.translation}
          values={translationProps.values}
        />
      </div>
    </div>
  );
});

export default Ticker;
